import React from 'react';
import { TextField } from '@mui/material';

const LabeledTextField = ({ label, ...props }) => (
  <TextField
    label={label} // MUI now controls the label
    variant="outlined"
    fullWidth
    style={{ marginBottom: '12px' }}
    // The 'required' prop is passed via ...props and MUI handles the asterisk
    sx={{
      // Style the label itself
      '& .MuiInputLabel-root': {
        color: 'grey',
        fontWeight: 'bold',
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: 2,
        boxShadow: '0 2px 10px 0 rgba(251, 114, 2, 0.35)',
        '& fieldset': {
          borderColor: '#fb7102',
          borderWidth: '2px',
        },
        '&:hover fieldset': {
          borderColor: '#fb7102',
          borderWidth: '2px',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#fb7102',
          borderWidth: '2px',
        },
      },
    }}
    {...props}
  />
);

export default LabeledTextField;